/**
 * Determines if a month is "old" (more than one month in the past).
 * Old months have frozen data — sessions and stats won't change.
 *
 * @param year - Full year (e.g., 2026)
 * @param month - Month number (1-12)
 * @returns True if the month is more than one month in the past
 */
export function isOldMonth(year: number, month: number): boolean {
    const now = new Date();
    const queryYearMonth = year * 100 + month;
    const cutoffYearMonth = now.getFullYear() * 100 + now.getMonth(); // Last month (0-indexed, so this is current month)

    return queryYearMonth < cutoffYearMonth;
}

/**
 * Determines if a book is "old" based on its scheduled month/year.
 * Old books have effectively frozen stats — users rarely rate them.
 *
 * @param month - Book's scheduled month (1-12), or null if unscheduled
 * @param year - Book's scheduled year, or null if unscheduled
 * @returns True if the book is scheduled for more than one month in the past
 */
export function isOldBook(month: number | null, year: number | null): boolean {
    if (month === null || year === null) {
        // Unscheduled book — treat as recent to be safe
        return false;
    }

    return isOldMonth(year, month);
}
